import { render } from "./Recovery.vue?vue&type=template&id=693403ae&scoped=true&ts=true"
import script from "./Recovery.vue?vue&type=script&lang=ts"
export * from "./Recovery.vue?vue&type=script&lang=ts"

import "./Recovery.vue?vue&type=style&index=0&id=693403ae&lang=scss&scoped=true"

import exportComponent from "/builds/hubevt/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-693403ae"]])

export default __exports__